import React, { useEffect, useState } from "react";
import './DatesTabsBlock.scss';
import { Container, Row, Col, Tab } from "react-bootstrap";
import DatesBlock from "./DatesBlock";

function DatesTabsBlock({ targetDate }) {
    const [activeTab, setActiveTab] = useState('dates00');

    const calculateDaysLeft = () => {
        const difference = new Date(targetDate) - new Date();
        if (difference <= 0) return 0;
        return Math.ceil(difference / (1000 * 60 * 60 * 24));
    };

    const getLeftWord = (num) => {
        const value = Math.abs(num) % 100;
        const lastDigit = value % 10;

        if (value > 10 && value < 20) return 'осталось';
        if (lastDigit === 1) return 'остался';
        return 'осталось';
    };

    const getDaysWord = (num) => {
        const value = Math.abs(num) % 100;
        const lastDigit = value % 10;

        if (value > 10 && value < 20) return 'дней';
        if (lastDigit > 1 && lastDigit < 5) return 'дня';
        if (lastDigit === 1) return 'день';
        return 'дней';
    };

    const [daysLeft, setDaysLeft] = useState(calculateDaysLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setDaysLeft(calculateDaysLeft());
        }, 60000);

        return () => clearInterval(timer);
    }, [targetDate]);

    return (
        <div id="dates" className={`dates-tabs-wrapper ${activeTab === "dates01" && "tab-active-1"} ${activeTab === "dates02" && "tab-active-2"} ${activeTab === "dates03" && "tab-active-3"}`}>
            <Tab.Container activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
                <div className="dates-container">
                    <DatesBlock activeTab={activeTab} />
                </div>

                <Tab.Content className="dates-tab-content">
                    <Tab.Pane eventKey="dates01">
                        <div className="tab1-pane">
                            <Container className="tab1-container p-0">
                                <Row className="w-100 m-0 align-items-center gy-4">
                                    <Col xs={12} xxl={7} className="tab1-left-side">
                                        <Row className="align-items-center gy-3">
                                            <Col xs={12} sm="auto" className="d-flex justify-content-center">
                                                <div className="tab1-days">
                                                    <div className="text-left">{getLeftWord(daysLeft)}</div>
                                                    <div className="text-num">{daysLeft}</div>
                                                    <div className="text-days">{getDaysWord(daysLeft)}</div>
                                                </div>
                                            </Col>
                                            <Col xs={12} sm className="p-0">
                                                <div className="tab1-text">
                                                    {"Регистрация начнется c 15 сентября \nи продлится до 14 октября 2026 года"}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={12} xxl={5} className="p-0">
                                        <a className="tab1-registry" href="/">
                                            <div className="tab1-registry-text">зарегистрироваться</div>
                                            <div className="tab1-registry-icon"></div>
                                        </a>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </Tab.Pane>


                    <Tab.Pane eventKey="dates02">
                        <div className="tab23-pane">
                            <p>Отборочный этап Начнется c 15 сентября и продлится до 14 октября 2026 года.</p>
                            <hr />
                            <h4>Как принять участие </h4>
                            <div className="white-rect">
                                <Container className="white-rect-container">
                                    <Row className="w-100 m-0 gy-4">
                                        <Col xs={12} lg={5} className="p-0 mt-0">
                                            <div className="title">
                                                <h4>Регистрация</h4>
                                                <div className="arrow"></div>
                                            </div>
                                        </Col>
                                        <Col xs={12} lg={7} className="p-0 mt-0">
                                            <div className="num-list">
                                                <div className="num-element">
                                                    <div className="num-dot">1</div>
                                                    <div className="text">Пройдите регистрацию на сайте</div>
                                                </div>
                                                <div className="num-element">
                                                    <div className="num-dot">2</div>
                                                    <div className="text">Изучите подробнее инструкцию</div>
                                                </div>
                                                <div className="num-element">
                                                    <div className="num-dot">3</div>
                                                    <div className="text">Перейдите на платформу https://cic-edu.ru</div>
                                                </div>
                                                <div className="num-element">
                                                    <div className="num-dot">4</div>
                                                    <div className="text">Пройдите тесторирование</div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                            <h4 className="darked">Критерии определения победителей</h4>
                            <p>Будут опубликованы по окончании отборочного этапа.</p>
                            <hr />
                            <h4 className="darked">Результаты отборочного этапа</h4>
                            <p>Результаты будут опубликованы до 16 октября 2026 года.</p>
                        </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="dates03">
                        <div className="tab23-pane tab3-pane">
                            <p>Заключительный этап Начнется c 19 октября и продлится до 23 октября 2026 года.</p>
                            <hr />
                            <h4>Как принять участие </h4>
                            <div className="white-rect">
                                <Container className="white-rect-container">
                                    <Row className="w-100 m-0 gy-4">
                                        <Col xs={12} lg={5} className="p-0 mt-0">
                                            <div className="first-col">
                                                <div className="attention-icon">!</div>
                                                <div className="info-container">
                                                    <div className="info">Информация о том, что вы прошли в заключительный этап, <strong>придет вам на почту</strong>, указанную при регистрации</div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} lg={7} className="p-0 mt-0">
                                            <div className="num-list">
                                                <div className="num-element">
                                                    <div className="num-dot">1</div>
                                                    <div className="text">Получить приглашение</div>
                                                </div>
                                                <div className="num-element">
                                                    <div className="num-dot">2</div>
                                                    <div className="text">Зайти в личный кабинет</div>
                                                </div>
                                                <div className="num-element">
                                                    <div className="num-dot">3</div>
                                                    <div className="text">Написать эссе</div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                            <h4 className="darked">Критерии определения победителей</h4>
                            <p>Будут опубликованы по окончании отборочного этапа.</p>
                            <hr />
                            <h4 className="darked">Результаты заключительного этапа</h4>
                            <p>Результаты будут опубликованы до 16 октября 2026 года.</p>
                        </div>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    );
}

export default DatesTabsBlock;
